export default __webpack_public_path__ + "img/success-story__zoon.86ac0de.svg";